import * as React from "react";
import { cn } from "../_internal/cn";
import type { TypeNarrativeHeadlineHighlightProps } from "./NarrativeHeadlineTypes";

/**
 * NarrativeHeadlineHighlight — paints a span of headline text with the AI
 * brand gradient (the "highlighted word" treatment). Drop it inline inside a
 * `<NarrativeHeadline>`:
 *
 *     <NarrativeHeadline>
 *       Headline with a <NarrativeHeadlineHighlight>highlighted</NarrativeHeadlineHighlight> word
 *     </NarrativeHeadline>
 */
const NarrativeHeadlineHighlight = React.forwardRef<
  HTMLSpanElement,
  TypeNarrativeHeadlineHighlightProps
>(({ children, className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn("seeds-narrative-headline-highlight", className)}
      {...props}
    >
      {children}
    </span>
  );
});

NarrativeHeadlineHighlight.displayName = "NarrativeHeadlineHighlight";

export default NarrativeHeadlineHighlight;
